import React from "react";
import { Card, Col, Form, Input, Row } from "antd";

const EventMetaSection: React.FC = () => {
  return (
    <Card type="inner" title="Meta properties (cố định: HOME, VISITOR, LEAGUE)" style={{ marginTop: 12 }}>
      <Form.List name={["envent", "metaProperties"]}>
        {(fields) => (
          <>
            {fields.map((mf) => (
              <Row key={mf.key} gutter={12} align="middle" style={{ marginBottom: 8 }}>
                <Col xs={24} md={8}>
                  <Form.Item {...mf} name={[mf.name, "name"]} fieldKey={[mf.fieldKey!, "name"]}>
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={16}>
                  <Form.Item {...mf} name={[mf.name, "value"]} fieldKey={[mf.fieldKey!, "value"]}>
                    <Input placeholder="Giá trị" />
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}
      </Form.List>
    </Card>
  );
};

export default EventMetaSection;

